// src/components/infra/InfraItemCard.jsx
import React from "react";
import RichTextRenderer from "../common/RichTextRenderer";

import pdfIcon from "../../assets/pdf.png";

const InfraItemCard = ({ item }) => {
  if (!item) return null;

  const { title, content, image, datasheet } = item;
  const imageUrl = image?.url ? `${image.url}` : "/placeholder-product-sm.jpg";
  const datasheetUrl = datasheet?.download_file?.url
    ? `${datasheet.download_file.url}`
    : null;

  const datasheetLinkText =
    datasheet?.download_title || datasheet?.download_file?.name || "Datasheet";

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-md flex flex-col sm:flex-row overflow-hidden group hover:shadow-lg transition-shadow duration-200">
      <div className="md:w-48 lg:w-56 xl:w-64 flex-shrink-0 p-3 sm:p-4 flex items-center justify-center border-b sm:border-b-0 sm:border-r border-gray-200">
        <img
          src={imageUrl}
          alt={image?.alternativeText || title || "Product Image"}
          className="max-w-full max-h-32 sm:max-h-40 object-contain"
        />
      </div>

      <div className="flex-grow p-4 sm:p-5 flex flex-col justify-between">
        {" "}
        <div>
          <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors">
            {title}
          </h3>

          <div className="max-w-none text-gray-700">
            <RichTextRenderer
              content={content}
              className="prose prose-ms max-w-none text-gray-800"
            />
          </div>
        </div>
        {datasheetUrl && (
          <div className="mt-3 pt-3">
            <a
              href={datasheetUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-xl text-blue-600 hover:text-blue-800 group/link"
            >
              <img
                src={pdfIcon}
                className="w-7 mr-2 text-red-600 group-hover/link:text-red-700 mr-1.5"
              />
              <span className="font-medium group-hover/link:underline">
                {datasheetLinkText}
              </span>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default InfraItemCard;
